import { render, staticRenderFns } from "./tool.file.metadata.logo.vue?vue&type=template&id=2fbc0208&scoped=true&"
import script from "./tool.file.metadata.logo.vue?vue&type=script&lang=js&"
export * from "./tool.file.metadata.logo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fbc0208",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\public\\Isaura\\id.es6.vn\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2fbc0208')) {
      api.createRecord('2fbc0208', component.options)
    } else {
      api.reload('2fbc0208', component.options)
    }
    module.hot.accept("./tool.file.metadata.logo.vue?vue&type=template&id=2fbc0208&scoped=true&", function () {
      api.rerender('2fbc0208', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/tool/file/tool.file.metadata.logo.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/views/tool/file/tool.file.metadata.logo.vue
// module id = 816
// module chunks = 3